// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__3Kzkm","row":"ProcedureTreatmentSummary_row__1zaTG"};